module.exports = __webpack_public_path__ + "static/media/17_plantilla_cuadrada_combo_simple_cp_gaseosas_vidrio_350_spsa.bd14d29d.png";